import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { Exchange, FeedbackType } from "./types/Exchange";
import Waiting from "./Waiting.vue";
import { useProtocolStore } from "./store/protocol-store";
import { BSpinner } from "bootstrap-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Feedback',
  props: {
    exchange: null
  },
  setup(__props: any) {

const props = __props as {
  exchange: Exchange;
};



const feedbackPositive = ref(true);

const protocolStore = useProtocolStore();

const providePositiveFeedback = async () => {
  if (props.exchange.feedbackType || !props.exchange.questionUuid) {
    return;
  }
  await protocolStore.submitFeedback(props.exchange.questionUuid, true);
};

const provideNegativeFeedback = () => {
  if (props.exchange.feedbackType) {
    return;
  }
  feedbackPositive.value = false;
};

const cancelNegativeFeedback = () => (feedbackPositive.value = true);

const feedbackFieldName = "feedback";

const thumbsUpColor = () => {
  if (props.exchange.feedbackType === FeedbackType.Positive) {
    return "success";
  }
  return "";
};

const thumbsDownColor = () => {
  if (props.exchange.feedbackType === FeedbackType.Negative) {
    return "danger";
  }
  return "";
};

const getIcon = (icon: string, feedbackType: FeedbackType) => {
  if (props.exchange.feedbackType === feedbackType) {
    return `${icon}-fill`;
  }
  return icon;
};

const submit = async (event) => {
  const formData = new FormData(event.target);

  const feedbackValue = formData.get(feedbackFieldName);

  if (typeof feedbackValue === "string" && props.exchange.questionUuid) {
    await protocolStore.submitFeedback(props.exchange.questionUuid, false, feedbackValue);
    feedbackPositive.value = true;
    event.target.reset();
  }
};

return { __sfc: true,props, feedbackPositive, protocolStore, providePositiveFeedback, provideNegativeFeedback, cancelNegativeFeedback, feedbackFieldName, thumbsUpColor, thumbsDownColor, getIcon, submit, FeedbackType, Waiting, BSpinner }
}

})